import DynamicObject from "../../models/dynamic-object";
import { AxiosResponse} from "axios";
import Api from "../api";

export default (adId : number,config?: DynamicObject): Promise<AxiosResponse> => {
    const path = 'posts'
    return Api.getInstance().request.get(`${path}/${adId}?expand=images,category,dynamicAttributes,bookmarkStatus,status,custom_param_string,city,jobApplicantCount,neighborhood,postUrl,searchMember,totalComments,imagesCount,note,price_list,chat_enabled,custom_param_array,vasExpiryMessages&VasExpiryMessagesList=VIP%2CTurbo%2CBumpup%2CPremium`, path)
}